export enum CloseTaskEventSource {
    Dashboard = "Dashboard",
    Dropdown = "Dropdown",
    Button = "Button",
}
